import axios from "@/lib/axios";
import { useMutation } from "@tanstack/vue-query";

export const useMarkable = () => {
  const setMarkable = async (idHotel: number | string) => {
    const { data } = await axios.post(`api/hotels/${idHotel}/favorites`);
    return data;
  };

  const removeMarkable = async (idHotel: number | string) => {
    const { data } = await axios.delete(`api/hotels/${idHotel}/favorites`);
    return data;
  };

  const setFavoriteHotel = useMutation((params: string | number) =>
    setMarkable(params),
  );

  const removeFavoriteHotel = useMutation((params: string | number) =>
    removeMarkable(params),
  );

  return {
    removeFavoriteHotelAsync: removeFavoriteHotel.mutateAsync,
    setFavoriteHotelAsync: setFavoriteHotel.mutateAsync,
  };
};
